import { useDispatch, useSelector } from "react-redux";
import {
  getOrbitDetails,
  setAdminStuff,
  setSelectOrbit,
  setVolunteersDetails,
} from "../../../../feature/orbit-slice";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../services/orbit-service";
import { getAuthDetails } from "../../../../feature/auth-slice/auth-slice";
import citizenService from "../../services/citizen-service";
import planetService from "../../services/planet-service";
import AdminDetails from "./admin-details";
import { btnConfig, tabview } from "./admin-config";
import AdminPagination from "./admin-pagination";
import SyPopup from "../../../../shared/components/sy-model";
import DetailPopup from "../../popups/detail-popup";
import { useSearchParams } from "react-router-dom";
import { adminParamValue, orbitParamValue } from "../../../../utils/helper";
import OrbConfirmation from "../../../../shared/components/orb-confirmation";
import socket from "../../../../utils/socket";

type Props = {};

const AdminScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { adminView, orbitId } = useParams();
  const authDetails = useSelector(getAuthDetails);
  const [view, setView] = useState<any>(
    adminView ? tabview[adminView] : tabview.planets
  );
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(adminParamValue(searchParams));
  const [open, setOpen] = useState<any>(true);
  const [headerData, setHeaderData] = useState<any>(null);
  const [openList, setOpenList] = useState<boolean>(false);
  const [listMode, setListMode] = useState<any>(null);
  const [adminListData, setAdminListData] = useState<any>([]);
  const [pageIndex, setPageIndex] = useState<any>(0);
  const orbitInfo = useSelector(getOrbitDetails);
  const [confirmData, setConfirmData] = useState<any>(null);
   const [openConfirmPopup, setConfirmPopup] = useState(false);
  
  let pageSize = 8;
  const ontabChange = (view: any) => {
    navigate({
      pathname: `/admin/${orbitInfo.selectOrbit}/${view}`,
      search: `?fr=${params.fr}`,
    });
    setView(tabview[view]);
  };

  const onClickAction = (icon: any, type: any, data: any) => {
    if (type === "citizens") {
      if (icon === "visible") {
        setOpen(false);
        const timeout = setTimeout(() => {
          navigate({
            pathname: `/profile/${data.usr_id}`,
            search: `?fr=${params.fr}`,
          });
        }, 500);
        return () => clearTimeout(timeout);
      } else if(icon === 'planet_visible'){
        const timeout = setTimeout(() => {
          navigate({
            pathname: `/view/planet/${orbitId}/${data.pro_id}`,
            search: `?fr=${params.fr}`,
          });
        }, 500);
        return () => clearTimeout(timeout);
      } else{
      
        setConfirmData(data);
        setConfirmPopup(true)
      }
    } else if (type === "volunteers") {
      if(icon ==='add_citizen'){     
        addCitizen(data)
      }
      if (icon === "visible") {
        setOpen(false);
        const timeout = setTimeout(() => {
          navigate({
            pathname: `/profile/${data.volunteer_id}`,
            search: `?fr=${params.fr}`,
          });
        }, 500);
        return () => clearTimeout(timeout);
      } 
      if(icon === 'planet_visible'){
        setOpen(false);
        const timeout = setTimeout(() => {
          navigate({
            pathname: `/view/planet/${orbitId}/${data.pro_id}`,
            search: `?fr=${params.fr}`,
          });
        }, 500);
        return () => clearTimeout(timeout);
      }
    } else if (type === "planets") {
      if (icon === "visible") {
        setOpen(false);
        const timeout = setTimeout(() => {
          navigate({
            pathname: `/view/planet/${orbitId}/${data.pro_id}`,
            search: `?fr=${params.fr}`,
          });
        }, 500);
        return () => clearTimeout(timeout);
      } else {
        setConfirmData(data.pro_id);
        setConfirmPopup(true)
      }
    }
  };

  const addCitizen =(data:any)=>{
   const payload ={
    com_id:authDetails.company_details.cmp_id,
    vol_id:data.volunteer_id,
    pro_id:data.pro_id,
     orb_id :orbitId
   }
   citizenAdd(payload)
  }


  const onCloseConfirmPop = () => {
    setConfirmPopup(false)
    setConfirmData(null)
  };

  const onPlanetTableAction = (val: any) => {
  
    if(val){
      deletePlanet(confirmData)
    }
    setConfirmPopup(false)
  };

  const onCitizenTableAction = (val: any) => {
    if(val){
      let payload:any = {
        status: confirmData.orb_status ? 0 : 1,
        usr_id: confirmData.usr_id,
        orb_id: Number(orbitId),
      };
        citizenStatusChange(payload)
    }
 
    setConfirmPopup(false)
  };

  const citizenStatusChange =(payload:any)=>{
    
        citizenStatus(payload);
  }

  const { mutate: deletePlanet } = useMutation({
    mutationFn: planetService.deletePlanet,
    onSuccess(data, variables, context) {
      updateList()
    
    },
  });

    const { mutate: citizenAdd } = useMutation({
      mutationFn: citizenService.citizenAdd,
      onSuccess(data, variables, context) {
        updateList()
      
      },
    });

  const { mutate: citizenStatus } = useMutation({
    mutationFn: citizenService.citizenStatus,
    onSuccess(data, variables, context) {
      updateList()
    }
  });

  const updateList=()=>{
    const payload: any = {
      orb_id: orbitId,
      pagination: { index: pageIndex, size: pageSize },
    };
    adminList(payload);
  
  }
  const { mutate: adminList } = useMutation({
    mutationFn: citizenService.adminList,
    onSuccess(data, variables, context) {
      setAdminListData(data.data);
    },
  });

  const updateAdminList = (type: any = null, value: any) => {
    getAdminList(type, value);
  };

  const getAdminList = (type: any = null, value: any = null) => {
    const payload: any = {
      orb_id: orbitId,
      pagination: { index: pageIndex, size: pageSize },
    };
    if (type === "planet") {
      payload.pro_id = value;
    } else if (type === "nav") {
      if (value === "pre") {
        setPageIndex(pageIndex - 1);
        payload.pagination.index = pageIndex - 1;
      } else {
        setPageIndex(pageIndex + 1);
        payload.pagination.index = pageIndex + 1;
      }
    }

    adminList(payload);
  };

  const onCloseDetailList = () => {
    dispatch(setVolunteersDetails(null));
    setOpenList(false);
  };

  const getPopupComponents = () => {

    const message = "are_you_sure_to_proceed_with_this_action"
  
    return (
      <>
        <SyPopup open={openList} onClose={onCloseDetailList} maxWidth={"sm"}>
          <DetailPopup listMode={listMode} onClose={onCloseDetailList} />
        </SyPopup>

        <SyPopup
        open={openConfirmPopup}
        onClose={onCloseConfirmPop}
        maxWidth={"xs"}
        backDrop={false}
      >
        <OrbConfirmation
          message={message}
          onConfirmClick={adminView==='planets'?onPlanetTableAction:onCitizenTableAction}
          buttons={btnConfig}
        />
      </SyPopup>
      </>
    );
  };

  useEffect(() => {

    dispatch(setSelectOrbit(orbitId));
    dispatch(setAdminStuff(true));
    getAdminList();
    
  }, []);




  return (
    <>
   
      <AdminDetails
        updateAdminList={updateAdminList}
        open={open}
        onClickTab={ontabChange}
        view={view}
        headerData={headerData}
        adminListData={adminListData}
        pageIndex={pageIndex}
        pageSize={pageSize}
        authDetails={authDetails}
        onClickAction={onClickAction}
      />
      {getPopupComponents()}
    </>
  );
};

export default AdminScreen;
